import { Modal, Button, Row, Col } from "react-bootstrap";
import { modal } from "@/utils/constant";

function RestartGameModal({ show, hide, loading, onConfirm }) {
  return (
    <Modal
      show={show}
      onHide={() => !loading && hide()}
      centered
      dialogClassName="custom-game-modal"
    >
      <Modal.Header className="bg-secondary" closeButton={!loading}>
        <Modal.Title>{modal?.restartGameModalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-14">
        <p className="mb-3">{modal?.restartGameModalIntro1}</p>
        <p className="mb-4">{modal?.restartGameModalIntro2}</p>
        <p className="fw-bold mb-2"><b>{modal?.restartGameModalHowItWorks}</b></p>
        <ul className="ps-3 mb-0">
          <li className="mb-1 mx-3">{modal?.restartGameModalBullet1}</li>
          <li className="mb-1 mx-3">{modal?.restartGameModalBullet2}</li>
          <li className="mb-1 mx-3">{modal?.restartGameModalBullet3}</li>
          <li className="mb-1 mx-3">{modal?.restartGameModalBullet4}</li>
        </ul>
        <Row className="mt-8">
          <Col>
          <Button
              variant="secondary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={onConfirm}
            >
              {loading ? modal?.restartGameModalResetting : modal?.restartGameModalContinue}
            </Button>
          </Col>
          <Col>
            <Button
              variant="outline-primary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={hide}
            >
              {modal?.cancle}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default RestartGameModal;
